import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserDiseasedTreesGame from 'src/games/DiseasedTreesGame/Main';

interface DiseasedTreesGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class DiseasedTreesGame extends React.Component<DiseasedTreesGameProps> {
    constructor(props: DiseasedTreesGameProps) {
        super(props);
        bindAllOfThis(this, DiseasedTreesGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserDiseasedTreesGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default DiseasedTreesGame;



// WEBPACK FOOTER //
// ./src/pages/game/DiseasedTreesGame.tsx